// App.js
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ComposeEmail from './components/ComposeEmail/ComposeEmail';
import EmailList from './components/EmailList/EmailList';
import EmailView from './components/EmailView/EmailView';
import LoginForm from './components/LoginForm/LoginForm';
import Sidebar from './components/Sidebar/Sidebar';


function App() {
  // State variables
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [showCompose, setShowCompose] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [credentials, setCredentials] = useState({
    imapHost: '',
    imapPort: '',
    smtpHost: '',
    smtpPort: '',
	email:'',
    username: '',
    password: ''
  });
  const [isEmailListHidden, setIsEmailListHidden] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState("INBOX");

// Dark mode handling
  const [darkMode, setDarkMode] = useState(
	window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  useEffect(() => {
	document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);
  
  
  // Show the clicked email
  const handleEmailSelect = (email) => {
    setSelectedEmail(email);
    setShowCompose(false);
    setIsEmailListHidden(true); // Hide email list when an email is selected
  };

  // Load emails when user logged in
  useEffect(() => {
    if (isLoggedIn) {
      fetchEmails();
    }
  }, [isLoggedIn]);
  const notify = () => toast("Wow so easy!");
  const notify3 = ( MSG ) => toast(MSG,{
			position: "bottom-right",
			autoClose: 3000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: false,
			theme: (darkMode?"dark":"light"),
			transition: "Slide"
			});
  const notify2 = ( MSG ) => toast(MSG, {
	  autoClose: 2000,
	  position: "bottom-right",
	  theme: (darkMode?"dark":"light")
  });
  const notify5 = ( MSG ) => toast(MSG, {
	  autoClose: 5000,
	  position: "bottom-right",
	  theme: (darkMode?"dark":"light")
  });

  // method that fetches the emails from api
  const fetchEmails = async (folder = selectedFolder) => {
	  notify2(`🦄 Sync ${folder} `);
	  setSelectedEmail(null);
    try {
      // localhost currently
      // const response = await fetch('http://localhost:8080/api/receive-emails', {
	  const response = await fetch('http://mail.l6.duckdns.org:8781/api/receive-emails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          host: credentials.imapHost,
          port: credentials.imapPort,
          username: credentials.username,
		  email: credentials.email,
          password: credentials.password,
          folder: folder // inbox, sent, drafts etc.
        }),
      });

      if (response.ok) {
        //const data = await response.json();
		const data = await response.json();
		console.log(data,response);
		
		data.keys(data).forEach(key=>{
			console.log(key ,data[key]);
			data[key].shortBody=data[key].body.substr(0,50);
			
			
		})
        setEmails(data);
		notify2(`🦄 Fetched Emails ${credentials.username}`);
      } else {
		  notify5(`🦄 Failed to fetch emails ${response.json()}`);
        console.error('Failed to fetch emails',response);
      }
    } catch (error) {
      console.error('Error fetching emails:', error);
	  notify5(`🦄 Error fetching emails ${error.message}`);
    }
  };

  const handleLogin = (loginData) => {
    setCredentials(loginData);
	if ( isLoggedIn ) setTimeout(() => {console.log(loginData); /*setCredentials(loginData)*/;fetchEmails()}, 2000);
	if ( isLoggedIn ) setEmails([]);
	//if ( isLoggedIn ) fetchEmails();
    setIsLoggedIn(true);
	setShowLogin(false);
  };
  
  const onHideLogin = () => {
	  setShowLogin(false);
  };

  const handleSendEmail = async (emailData) => {
    try {
      // object for sending both text fields and files
      const formData = new FormData();

      // Add text fields
      formData.append('host', credentials.smtpHost);
      formData.append('port', credentials.smtpPort);
      formData.append('username', credentials.username);
	  //formData.append('from', credentials.email);
      formData.append('password', credentials.password);
      formData.append('to', emailData.to);
      formData.append('subject', emailData.subject);
      formData.append('body', emailData.body);
		
		
      // Add attachments if there are any
      if (emailData.attachments && emailData.attachments.length > 0) {
        emailData.attachments.forEach(file => {
          formData.append('attachments', file);
        });
      }

      //const response = await fetch('http://localhost:8080/api/send-email', {
	  const response = await fetch('http://mail.l6.duckdns.org:8781/api/send-email', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setShowCompose(false);
        // Refresh inbox after sending
        fetchEmails();
      } else {
        const errorData = await response.json();
        console.error('Failed to send email:', errorData.message);
        //alert(`Failed to send email: ${errorData.message}`);
		notify2(`🦄 Failed to send email: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error sending email:', error);
	  notify2(`🦄 Error sending email: ${error.message}`);
      //alert('Error sending email. Please try again.');
    }
  };

  if (!isLoggedIn) {
    return (
		<div>
		<LoginForm onLogin={handleLogin} />
		<button
		onClick={() => setDarkMode(!darkMode)}
		className="theme-toggle"
		aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
		>
		{darkMode ? '☀️' : '🌙'}
		</button>
		<div className="AppToast">
			<ToastContainer autoClose={true} />
		</div>
	  </div>
	  );
  }
	
  return (
    <div className="app">
      <div className="app-container">
		
        <Sidebar
          onComposeClick={() => setShowCompose(true)}
          onRefreshClick={fetchEmails}
		  onLoginClick = { () => setShowLogin(true)}
          onSelectFolder={(folder) => {
            setSelectedFolder(folder);
            fetchEmails(folder); // Refresh emails when changing folder
          }}
          selectedFolder={selectedFolder}
        />

        <div className="main-content">
          <EmailList
            emails={emails}
            onSelectEmail={handleEmailSelect}
            selectedEmailId={selectedEmail ? selectedEmail.id : null}
            hidden={isEmailListHidden}
            selectedFolder={selectedFolder} // Pass selected folder name to update h2 title
          />

          {selectedEmail && (
            <EmailView
              email={selectedEmail}
			  onSend={handleSendEmail}
              onClose={() => {
                setSelectedEmail(null);
                setIsEmailListHidden(false); // Show email list when closing an email
              }}
            />
          )}
        </div>
      </div>

      {showCompose && (
        <ComposeEmail
          onClose={() => setShowCompose(false)}
          onSend={handleSendEmail}
        />
      )}
	  
	  {showLogin && (
	  <div className="LoginHolder">
		
		<LoginForm onLogin={handleLogin} />
		
		<button className="close-button_Lbox" onClick={onHideLogin}>×</button>
	  </div>
	  )}
	  
	  <div className="toolbar"><small>Web<span>Mail</span> oglasi.rs</small><br/><small>{credentials.hasOwnProperty('username')? credentials.username:""}</small></div>
	  
	  <button
		onClick={() => setDarkMode(!darkMode)}
		className="theme-toggle"
		aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
		{darkMode ? '☀️' : '🌙'}
	  </button>
	  
		<ToastContainer />
	  
    </div>
  );
}

export default App;
/*


11 dedicated
5 vps

*/